import React from "react";
import AnimateCC from "../../animate";
import { LunaparkMenu } from "../lunapark_menu/LunaparkMenu";
import { BalloonsGame } from "./BalloonsGame";
import additionalSounds from "./BalloonsGameSounds";
const BalloonsComponent: React.FC<{ frame: LunaparkMenu }> = ({ frame }) => {
    const game = React.useRef(new BalloonsGame(frame));

    return (
        <AnimateCC
            base="/lunapark/balloons"
            animationName="balloons"
            additionalSounds={additionalSounds}
            onLoaded={game.current.loaded}
        />
    );
};
export default BalloonsComponent;
